import * as React from 'react'
import KNB from '@wmfe/mach-pro-knb'
import { IndexPath, SectionList, ISection } from '@wmfe/mach-pro-components-react'
import { CouponPack, CouponItem, CouponUpgradeModal } from '@sailor/marketing-growth-components'
import { isArray, compact, isEmpty } from 'lodash'
import EmptyView from '@Pages/coupon/components/EmptyView'
import CommonDialog from '@Pages/coupon/components/CommonDialog'
import { reportRaptorMetrics } from '@Common/SLRaptor'
import { jumpTo, RouterType, getUserLocation, isJSON } from '@/common/utils'
import { ModuleLxType, pageTracker, moduleTracker } from '@/common/lx'
import NavigateBar from '@/components/NavigateBar'
import { SCHEME_MACHPRO_WITH_PRE } from '@/mkt_machpro/pages/coupon/constants'
import { jsonParse } from '@/mkt_machpro/pages/coupon/utils'
import { CouponReminderInfoType, PageSourceType, PreUseCouponStatus, CouponPackType, SaleChannel, InflateCouponType } from '@/mkt_machpro/pages/coupon/constants/CouponConstant'
import JudasConstant from '@/mkt_machpro/pages/coupon/constants/JudasConstant'
import { OrderCouponsRequest, OrderCouponInfo, OrderCouponsExchangeRequest, ApInputRequest, CouponUpgradeRequest } from '@/mkt_machpro/pages/coupon/service/model'
import { orderCouponListRequest, orderCouponExchange, couponUpgrade } from '@/mkt_machpro/pages/coupon/service/api'
import i18nClient from '@/mkt_machpro/pages/coupon/OrderCoupon/i18n.config'
import { THIRD_APP_NAME, THIRD_APP_SCHEME, THIRD_APP_PACKAGE } from '@/mkt_machpro/pages/coupon/OrderCoupon/constant'
import OrderCouponPromoDialog from '@/mkt_machpro/pages/coupon/OrderCoupon/components/OrderCouponPromoDialog'
import '@/mkt_machpro/pages/coupon/OrderCoupon/index.css'


// ----- mpweb适配origin -----
// ----- mpweb适配change -----
const payReminderTypes = [CouponReminderInfoType.payment_user_version_old, CouponReminderInfoType.payment_restriction];
// ----- mpweb适配       -----

const SLCommon = Mach.requireModule('SLCommon')
const Toast = Mach.requireModule('Toast')

const sectionType = {
  available: 0, // 可用
  unavailable: 1, // 不可用
}

enum DialogButtonType {
  Left = 0, // 左侧按钮
  Right = 1, // 右侧按钮（高亮）
}
interface IState {
  shopRegion: string // 门店地区
  disabledCouponList: any[] // 不可用优惠券列表
  enabledCouponList: any[] // 可用优惠券列表
  couponPackData: any // 券包数据
  emptyText: string | string[]
  selectedCouponAmount: number
  selectedCouponId: string
  showPaymentChannelDialog: boolean // 展示支付渠道限制弹窗
  promoDialogVisible: boolean
  promoFailTips: string
  commonDialogInfo: {
    title: string
    message?: string
    leftBtnText?: string
    rightBtnText?: string
    onClickLeftBtn?: (() => void) | undefined
    onClickRightBtn?: () => void
  }
  showBestDiscount: boolean
  loading: boolean
  // 回传提单页数据
  backOrderPageData: {
    paymethodList: any[]
    changedPackages: ApInputRequest[] // 券包变更信息
  }
  // 券包埋点相关数据
  haveReportedCouponPack: boolean // 是否上报过券包组件埋点
  haveReportedVoucherPack: Map<any, boolean> // 是否上报过券包卡片埋点
  haveChoosedVoucherPack: Map<any, boolean> // 是否勾选过券包卡片
  // 膨胀券相关数据
  couponUpgradeModalVisible: boolean // 膨胀券弹窗是否展示
  couponUpgradeModalData: any // 膨胀券弹窗数据
}

/**
 * 订单-优惠券列表
 */
export default class OrderCoupon extends React.Component<any, IState> {
  sectionListRef: any

  // 可用券曝光的indexPathMap
  enabledCouponExposedIndexPathMap: Set<string> = new Set()

  // 不可用券曝光的indexPathMap
  disabledCouponExposedIndexPathMap: Set<string> = new Set()

  hasFirstOrderCoupon = false

  exchangeCoupon = {
    enabledCoupon: [] as any[],
    disabledCoupon: [] as any[],
  }

  renderStartTime = 0

  isInited = false

  couponListReqApExtra: any // 券列表请求的apExtra, 透传搭售额外参数

  /** 当前选中的膨胀券 */
  currentUpgradeCoupon: any = {}

  /** 当前膨后券id */
  upgradedCouponId = ''

  constructor (props: object) {
    super(props)
    this.state = {
      shopRegion: 'HK',
      enabledCouponList: [],
      disabledCouponList: [],
      couponPackData: null,
      emptyText: [i18nClient.getText('coupon_display_list_default_text')],
      selectedCouponAmount: 0,
      selectedCouponId: '',
      showPaymentChannelDialog: false,
      promoDialogVisible: false,
      promoFailTips: '',
      commonDialogInfo: {
        title: '',
        message: '',
        leftBtnText: '',
        rightBtnText: '',
        onClickLeftBtn: () => {},
        onClickRightBtn: () => {},
      },
      showBestDiscount: false,
      loading: false,
      backOrderPageData: {
        paymethodList: [],
        changedPackages: Mach.data?.changedPackages || [],
      },
      haveReportedCouponPack: false,
      haveReportedVoucherPack: new Map(),
      haveChoosedVoucherPack: new Map(),
      couponUpgradeModalVisible: false,
      couponUpgradeModalData: {},
    }
    this.couponListReqApExtra = {}
  }

  componentDidMount () {
    this.renderStartTime = Date.now()
    // 上报券列表曝光量
    reportRaptorMetrics({ coupon_list_pv: 1 })
    this.reqCouponList()
    const page_source = Mach.env.schemeParams?.page_source || 1
    pageTracker({ cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID, valLab: { page_source } })
    moduleTracker({ type: ModuleLxType.MV, cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID, bid: JudasConstant.MY_COUPON_HISTORY_ENTRY_MV, valLab: { page_source } })
  }

  componentDidUpdate (prevProps: Readonly<any>, prevState: Readonly<IState>): void {
    if ((prevState.enabledCouponList !== this.state.enabledCouponList || prevState.disabledCouponList !== this.state.disabledCouponList) && !this.isInited) {
      this.isInited = true
      const duration = Date.now() - this.renderStartTime
      // 上报券列表渲染时长
      reportRaptorMetrics({ couponList_render_cost_time: duration }, { costTime: duration })
    }
  }

  reqCouponList = () => {
    if (!Mach.data) {
      return
    }

    const shopId = Mach.data.shopId
    const couponViewId = Mach.data.couponViewId
    const addressInfo = Mach.data.addressInfo
    const couponThresholdInfo = Mach.data.couponThresholdInfo
    const orderSource = Mach.data.orderSource
    const userGetMode = Mach.data.userGetMode || 'delivery' // 默认外卖
    const orderToken = Mach.data.token
    const { actualLatitude, actualLongitude } = getUserLocation()
    const bundleVersion = Mach.env.bundleVersion ?? ''
    // 第三方APP安装信息列表
    const appInstallationInfoList = this.getAppInstallInfoList()
    // 入参构造
    const orderCouponsReqParams: OrderCouponsRequest = {
      userGetMode: userGetMode,
      couponViewId: couponViewId,
      shopId: shopId,
      actualLongitude: actualLongitude,
      actualLatitude: actualLatitude,
      addressInfo: addressInfo,
      orderSource: orderSource,
      couponThresholdInfo: couponThresholdInfo,
      appInstallationInfoList,
      bundleVersion,
      orderToken,
      apInputReqs: this.state.backOrderPageData?.changedPackages,
      apExtra: this.couponListReqApExtra,
    }
    this.setState({
      loading: true,
    })
    // 接口请求
    orderCouponListRequest(orderCouponsReqParams)
      .then(result => {
        this.exchangeCoupon = {
          enabledCoupon: new Array((result?.enabledCouponList || []).length).fill(false),
          disabledCoupon: new Array((result?.disabledCouponList || []).length).fill(false),
        }
        this.hasFirstOrderCoupon = result?.hasFirstOrderCoupon
        if (result?.enabledCouponList) {
          const filterList = (result?.enabledCouponList || []).filter((item: OrderCouponInfo) => item.selected === true)
          if (filterList && filterList.length > 0) {
            this.setState(
              prevState => ({
                selectedCouponAmount: filterList[0].couponAmountString,
                selectedCouponId: filterList[0].couponViewId,
                backOrderPageData: {
                  ...prevState.backOrderPageData,
                  paymethodList: filterList[0]?.payChannelInfo?.payChannelCodeList || [],
                },
              }),
              () => {
                this.confirmClick(false)
              },
            )
            // 首次进页面将选中券移动至首位
            ;(result?.enabledCouponList || []).forEach((item: OrderCouponInfo, index: number) => {
              if (filterList[0].couponViewId === item.couponViewId) {
                result?.enabledCouponList.unshift(result?.enabledCouponList.splice(index, 1)[0])
              }
            })
          }

          // ----- mpweb适配origin -----
          // ----- mpweb适配change -----
          // @ts-ignore
          result.enabledCouponList = (result?.enabledCouponList || []).filter((item: OrderCouponInfo) => {
            if (payReminderTypes.includes(item?.couponReminderInfo?.type)) {
              if (!item.unusableReasonDocList?.length) {
                item.unusableReasonDocList = item.shortUseRuleDocList;
              }
              // @ts-ignore
              result.disabledCouponList = result?.disabledCouponList || [];
              // @ts-ignore
              result.disabledCouponList.push({ ...item })
              return false;
            } else {
              return true;
            }
          })
          // ----- mpweb适配       -----
        }
        const enabledCouponList = result?.enabledCouponList || []
        const hasBestDiscount = enabledCouponList.some((item: any) => item?.extra?.bestDiscountType === '1') // 有最佳优惠
        let currentTime = 0
        if (SLCommon?.getStorage && SLCommon?.setStorage) {
          const bestDiscountShowTimes = SLCommon?.getStorage({
            key: 'bestDiscountShowTimes',
          })
          currentTime = Number(bestDiscountShowTimes || 0)
          if (hasBestDiscount && currentTime < 3) {
            this.setState({
              showBestDiscount: true,
            })
            SLCommon?.setStorage({
              key: 'bestDiscountShowTimes',
              value: String(currentTime + 1),
            })
          }
        }
        this.setState({
          loading: false,
          shopRegion: result?.shopRegion || 'HK',
          enabledCouponList,
          disabledCouponList: result?.disabledCouponList || [],
          couponPackData: result?.apPreviewData,
          emptyText: [i18nClient.getText('coupon_display_list_default_text', '暂无优惠券')],
        })
        this.reportCouponCount(enabledCouponList)
        this.updateBackOrderPageData(result?.apPreviewData)
        this.updateCouponListReqApExtra(result?.apPreviewData)
      })
      .catch(error => {
        if (error === 'error') {
          this.setState({
            loading: false,
            emptyText: i18nClient.getText('coupon_display_list_access_error_text', '网络异常，请稍后重试'),
          })
        } else {
          this.setState({
            loading: false,
            emptyText: [i18nClient.getText('coupon_display_list_default_text', '暂无优惠券')],
          })
        }
      })
  }

  renderCouponPack = () => {
    // 提单页与券列表页新旧版本兼容
    // ----- mpweb适配origin -----
    // if (Mach.data?.features?.voucherPackage?.supported) {
    // ----- mpweb适配change -----
    // @ts-ignore
    if (Mach.data?.features?.voucherPackage?.supported && !Mach.env?.isH5) {
      // ----- mpweb适配       -----
      return (
        <CouponPack
          style={{ margin: '16 0 4 2' }}
          data={this.state.couponPackData}
          saleChannel={5}
          i18nClient={i18nClient}
          lxConfig={this.getCouponPackLxConfig()}
          onChange={this.handleCouponPackChoose}
        />
      )
    }
    return null
  }

  renderEmptyView = (isShowEmptyView: boolean) => {
    if (isShowEmptyView) {
      return (
        <view className="empty-wrap">
          <EmptyView emptyText={this.state.emptyText} />
        </view>
      )
    }
    return null
  }

  sectionData = () => {
    const { enabledCouponList, disabledCouponList } = this.state
    const sections = []
    if (enabledCouponList && enabledCouponList.length > 0) {
      sections.push({
        type: sectionType.available,
        data: this.state.enabledCouponList,
      })
    }
    if (disabledCouponList && disabledCouponList.length > 0) {
      sections.push({
        type: sectionType.unavailable,
        data: this.state.disabledCouponList,
      })
    }
    return sections
  }

  renderSectionHeader = (section: ISection) => {
    const { available, unavailable } = sectionType
    const { enabledCouponList, disabledCouponList } = this.state
    if (enabledCouponList && enabledCouponList.length > 0 && section?.data?.type === available) {
      return <text className="header-text">{i18nClient.getText('coupon_list_useable_title')}</text>
    }
    if (disabledCouponList && disabledCouponList.length > 0 && section?.data?.type === unavailable) {
      return <text className="unuseable-header-text">{i18nClient.getText('coupon_list_unuseable_title')}</text>
    }
    return null
  }

  /**
   * 格式化券数据, 与券组件保持一致
   */
  formatCouponData = (data: any) => {
    const { shopRegion } = this.state
    const couponInfo = {
      couponBaseInfoDto: {
        couponViewId: data?.couponViewId, // 券id
        couponConfigId: data?.couponConfigId, // 券配置id
        discountType: data?.discountType, // 折扣类型
        subCategory: data?.subCategory, // 券子类型
        packSceneId: data?.packSceneId, // 券所在券包的类型
        region: shopRegion, // 地区
      },
      couponDisplayInfoDto: {
        couponAmountSplitResult: data?.extra?.couponAmountSplitResult, // 小数点修改新增满减券结构
        // couponAmountSplitResult: {
        //   numberText:data?.couponAmountSplitResult?.numberText,
        //   decimal:data?.couponAmountSplitResult?.decimal
        // },
        couponAmountString: data?.couponAmountString, // 券面价格：单位元
        couponAmountText: data?.couponAmountText, // 券面文案
        currencyType: data?.currencyType, // 单位：如HK$
        sillAmountText: data?.sillAmountText, // 第一限制条件门槛文案：如满100可用、无门槛
        count: data?.count, // 券张数
        couponLabelInfo: data?.couponLabelInfo, // 券标签
        couponBackgroundInfo: data?.couponBackgroundInfo, // 左侧底纹图片url
        name: data?.name, // 券标题
        shortDescription: data?.shortDescription, // 运费优惠
        shortUseRuleDocList: data?.shortUseRuleDocList, // 标签字段
        shortUseRuleDoc: data?.shortUseRuleDoc, // 第二限制条件
        available: true, // 券是否可用
        expiredDays: data?.expiredDay, // 券过期天数
        validTimeText: data?.validTimeText, // 有效期文案
        exchangeCode: data?.exchangeCode, // 兑换码
        useRuleDocList: data?.useRuleDocList, // 券使用规则
        invalidReasonDocList: data?.unusableReasonDocList, // 券失效原因
        extra: data?.extra, // 提单页是否有最佳优惠
        inflateCouponDisplayInfo: {
          canUpgrade: data?.inflateCouponInfo?.canUpgrade, // 是否可膨
          inflateCouponType: data?.inflateCouponInfo?.inflateCouponType, // 膨后券类型
          upgradeAmountText: data?.inflateCouponInfo?.upgradeAmountText, // 如果可膨，膨后券的金额，单位元或同类单位，保留两位小数，末尾去0
          canDowngrade: data?.inflateCouponInfo?.canDowngrade, // 是否可逆膨
        },
      },
    }
    return couponInfo
  }

  renderItem = (item: any, { hasUnableOrderCoupon }: { hasUnableOrderCoupon: boolean }) => {
    const { data, indexPath } = item
    const { enabledCouponList, disabledCouponList } = this.state
    const lab = this.getCommonLab(item?.data, indexPath)
    if (!data?.unusableReasonDocList) {
      return (
        <CouponItem
          data={this.formatCouponData(data)}
          showScene="order_coupon_list_able"
          isExchangeCoupon={this.exchangeCoupon.enabledCoupon[indexPath.item]}
          isLastOne={!hasUnableOrderCoupon && enabledCouponList.length === indexPath.item + 1}
          isSelected={data.selected}
          showBestDiscount={this.state.showBestDiscount}
          itemsMargin="12"
          i18nClient={i18nClient}
          showUpgradeBtn
          onCouponSelect={() => {
            this.selectCoupon(indexPath, data)
          }}
          onRuleIconClick={() => {
            moduleTracker({ cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID, bid: JudasConstant.ORDER_CONFIRM_COUPON_URLE_MC, valLab: lab })
          }}
          onUpgradeBtnClick={() => this.handleCouponListUpgradeBtnClick(data, indexPath)}
          onUpgradeBtnView={() => {
            reportRaptorMetrics({ UPGRADE_BTN_MV: 1 }, { source: SaleChannel.COUPON_LIST_PAGE, coupon_id: data?.couponConfigId })
          }}
        />
      )
    }
    if (data?.unusableReasonDocList && (data?.unusableReasonDocList || []).length > 0) {
      return (
        <CouponItem
          data={this.formatCouponData(data)}
          showScene="order_coupon_list_unable"
          isExchangeCoupon={this.exchangeCoupon.disabledCoupon[indexPath.item]}
          isLastOne={disabledCouponList.length === indexPath.item + 1}
          itemsMargin="12"
          i18nClient={i18nClient}
          onRuleIconClick={() => {
            moduleTracker({ cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID, bid: JudasConstant.ORDER_CONFIRM_COUPON_URLE_MC, valLab: lab })
          }}
        />
      )
    }
    return null
  }

  cellHeightCacheKey = (indexPath: IndexPath) => {
    // @ts-ignore
    const { enabledCouponList, disabledCouponList } = this.state
    const { available, unavailable } = sectionType
    const { section, item = 0 } = indexPath || {}
    let couponId = 0
    if (enabledCouponList && enabledCouponList.length > 0) {
      if (section === available) {
        couponId = enabledCouponList[item]?.couponViewId
      } else if (section === unavailable) {
        couponId = disabledCouponList[item]?.couponViewId
      }
    } else if (disabledCouponList && disabledCouponList.length > 0) {
      couponId = disabledCouponList[item]?.couponViewId
    }
    return `${indexPath.item}+${indexPath.section}+${couponId}`
  }

  onCellAppear = (indexPath: any) => {
    if (indexPath.section === sectionType.available && (this.state?.enabledCouponList || []).length) {
      const couponInfo: OrderCouponInfo = this.state?.enabledCouponList[indexPath.item]
      const couponViewId = couponInfo ? couponInfo?.couponViewId : null
      if (!couponViewId) {
        return
      }
      // 可用券曝光埋点
      if (!this.enabledCouponExposedIndexPathMap.has(couponViewId)) {
        this.enabledCouponExposedIndexPathMap.add(couponViewId)
        const lab = this.getCommonLab(couponInfo, indexPath)
        const isInflateCoupon = couponInfo?.inflateCouponInfo?.inflateCouponType === InflateCouponType.INFLATED
        const couponLab = {
          ...lab,
          button_status: couponInfo?.selected,
          coupon_id: isInflateCoupon ? -999 : couponInfo?.couponConfigId,
          upgraded_coupon_id: isInflateCoupon ? couponInfo?.couponConfigId : -999,
        }
        moduleTracker({ type: ModuleLxType.MV, cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID, bid: JudasConstant.ORDER_CONFIRM_COUPON_ENABLE_COUPON_MV, valLab: couponLab })
      }
    }
    if (indexPath.section === sectionType.unavailable && (this.state?.disabledCouponList || []).length) {
      const couponInfo: OrderCouponInfo = this.state?.disabledCouponList[indexPath.item]
      const couponViewId = couponInfo ? couponInfo?.couponViewId : null
      if (!couponViewId) {
        return
      }
      // 不可用券曝光埋点
      if (!this.disabledCouponExposedIndexPathMap.has(couponViewId)) {
        this.disabledCouponExposedIndexPathMap.add(couponViewId)
        const lab = this.getCommonLab(couponInfo, indexPath)
        const isInflateCoupon = couponInfo?.inflateCouponInfo?.inflateCouponType === InflateCouponType.INFLATED
        const couponLab = {
          ...lab,
          button_status: couponInfo?.selected,
          unusable_reason: Object.keys(jsonParse(couponInfo?.extra?.unusableReasonDetail)).join(','),
          coupon_id: isInflateCoupon ? -999 : couponInfo?.couponConfigId,
          upgraded_coupon_id: isInflateCoupon ? couponInfo?.couponConfigId : -999,
        }
        moduleTracker({ type: ModuleLxType.MV, cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID, bid: JudasConstant.ORDER_CONFIRM_COUPON_UNABLE_COUPON_MV, valLab: couponLab })
      }
    }
  }

  getCommonLab = (couponInfo: OrderCouponInfo, indexPath: any) => {
    const pageSource = Mach.env.schemeParams?.page_source || 1
    const lab = {
      coupon_id: couponInfo.couponConfigId,
      coupon_index: indexPath.item,
      coupon_name: couponInfo.name,
      page_source: pageSource,
    }
    return lab
  }

  /**
   * 点击选择券
   */
  selectCoupon = (indexPath: IndexPath, item: OrderCouponInfo) => {
    const lab = this.getCommonLab(item, indexPath)
    const isInflateCoupon = item?.inflateCouponInfo?.inflateCouponType === InflateCouponType.INFLATED
    const couponLab = {
      ...lab,
      button_status: item.selected,
      coupon_id: isInflateCoupon ? -999 : item?.couponConfigId,
      upgraded_coupon_id: isInflateCoupon ? item?.couponConfigId : -999,
    }
    moduleTracker({ cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID, bid: JudasConstant.ORDER_CONFIRM_COUPON_ENABLE_COUPON_MC, valLab: couponLab })
    // 如果可用券列表有首单券且用户选中的是非首单券
    if (!item.selected && !item?.firstOrderLimit && this.hasFirstOrderCoupon) {
      this.selectNonFirstOrderLimitCoupon({ pop_type: 1, coupon_id: item?.couponConfigId }, (clickBtnType, clickBtnText) => {
        if (clickBtnType === DialogButtonType.Left) {
          this.selectCouponContinue(indexPath, item)
        }
        moduleTracker({
          cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
          bid: JudasConstant.ORDER_COUPON_FIRSE_LIMIT_MC,
          valLab: {
            pop_type: 1,
            coupon_id: item?.couponConfigId,
            button_name: clickBtnText,
          },
        })
      })
    } else {
      this.selectCouponContinue(indexPath, item)
    }
  }

  selectCouponContinue = (indexPath: IndexPath, item: OrderCouponInfo) => {
    // 如果选中的是支付渠道限制券
    if (!item.selected && item?.couponReminderInfo) {
      this.selectPaymentChannelCoupon(item)
      return
    }
    const paymethodList = item.payChannelInfo?.payChannelCodeList ?? []
    if (!item.selected) {
      this.setState(
        prevState => ({
          selectedCouponId: item.couponViewId,
          backOrderPageData: {
            ...prevState.backOrderPageData,
            paymethodList,
          },
        }),
        () => {
          this.confirmClick(true)
        },
      )
    } else {
      this.setState(
        prevState => ({
          selectedCouponId: '',
          backOrderPageData: {
            ...prevState.backOrderPageData,
            paymethodList: [],
          },
        }),
        () => {
          this.confirmClick(false)
        },
      )
    }
    const { enabledCouponList, selectedCouponId } = this.state
    const newEnabledCouponList = enabledCouponList.map(v => ({
      ...v,
      selected: item.couponViewId === v.couponViewId ? !v.selected : false,
    }))

    this.setState({
      enabledCouponList: newEnabledCouponList,
      selectedCouponAmount: !item.selected ? +item.couponAmountString : 0,
    })
  }

  /**
   * 选择了非首单券的交互
   */
  selectNonFirstOrderLimitCoupon = (lab: any, onClick: (clickBtnType: number, clickBtnText: string) => void) => {
    moduleTracker({
      type: ModuleLxType.MV,
      cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
      bid: JudasConstant.ORDER_COUPON_FIRSE_LIMIT_MV,
      valLab: lab,
    })
    this.setState({
      showBestDiscount: false,
      showPaymentChannelDialog: true,
      commonDialogInfo: {
        title: i18nClient.getText('coupon_use_list_fistorder_popup_title') || '',
        message: i18nClient.getText('coupon_use_list_fistorder_popup_subtitle') || '',
        leftBtnText: i18nClient.getText('coupon_use_list_fistorder_popup_button_left') || '',
        rightBtnText: i18nClient.getText('coupon_use_list_fistorder_popup_button_right') || '',
        onClickLeftBtn: () => {
          this.setState(
            {
              showPaymentChannelDialog: false,
            },
            () => {
              onClick?.(DialogButtonType.Left, i18nClient.getText('coupon_use_list_fistorder_popup_button_left'))
            },
          )
        },
        onClickRightBtn: () => {
          this.setState(
            {
              showPaymentChannelDialog: false,
            },
            () => {
              onClick?.(DialogButtonType.Right, i18nClient.getText('coupon_use_list_fistorder_popup_button_right'))
            },
          )
        },
      },
    })
  }

  /**
   * 选择了支付渠道券的交互
   */
  selectPaymentChannelCoupon = (item: OrderCouponInfo, isExchange = false) => {
    const title = item?.couponReminderInfo?.title || ''
    const message = item?.couponReminderInfo?.content || ''
    const coupon_id = item?.couponConfigId || ''
    const payment_method = item?.payChannelInfo?.payChannelCodeList?.join(',')
    const lab = { coupon_id, payment_method }
    const couponViewId = item?.couponViewId || ''
    if (item?.couponReminderInfo.type === CouponReminderInfoType.payment_restriction) {
      const page_source = Mach.env.schemeParams?.page_source || 1
      const leftBtnText = i18nClient.getText('coupon_submit_paymentlimit_popup_button_left')
      const rightBtnText = i18nClient.getText('coupon_submit_paymentlimit_popup_button_right')
      Object.assign(lab, { page_source })
      this.showPaymentLimitPopupView({ title, message, leftBtnText, rightBtnText }, clickBtnType => {
        // 继续
        if (clickBtnType === DialogButtonType.Right) {
          this.onClicPaymentChannelCouponkRightBtn(item)
        } else {
          // 兑换券取消逻辑，取消应用后刷新当前列表
          if (isExchange) {
            this.unuseableCouponCloseClick(couponViewId, this.state.selectedCouponId)
          }
        }
        // 点击埋点
        const button_name = clickBtnType === DialogButtonType.Left ? leftBtnText : rightBtnText
        Object.assign(lab, { button_name })
        moduleTracker({
          cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
          bid: JudasConstant.ORDER_COUPON_PAYMENT_LIMIT_DIALOG_MC,
          valLab: lab,
        })
      })
      // 支付限制弹窗曝光埋点
      moduleTracker({
        type: ModuleLxType.MV,
        cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
        bid: JudasConstant.ORDER_COUPON_PAYMENT_LIMIT_DIALOG_MV,
        valLab: lab,
      })
    } else if (item?.couponReminderInfo.type === CouponReminderInfoType.payment_user_version_old) {
      // 低版本提示
      const rightBtnText = i18nClient.getText('coupon_submit_paymentlimit_lowversion_button_text')
      this.showPaymentLimitPopupView({ title, message, rightBtnText }, clickBtnType => {
        if (clickBtnType === DialogButtonType.Right) {
          this.setState(
            {
              showPaymentChannelDialog: false,
            },
            () => {
              if (isExchange) {
                this.unuseableCouponCloseClick(couponViewId, this.state.selectedCouponId)
              }
            },
          )
          moduleTracker({
            cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
            bid: JudasConstant.ORDER_COUPON_PAYMENT_LIMIT_OLD_VERSION_MC,
            valLab: lab,
          })
        }
      })
      // 支付限制低版本弹窗曝光埋点
      moduleTracker({
        type: ModuleLxType.MV,
        cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
        bid: JudasConstant.ORDER_COUPON_PAYMENT_LIMIT_OLD_VERSION_MV,
        valLab: lab,
      })
    }
  }

  // 展示支付限制弹窗
  showPaymentLimitPopupView = (popupInfo: any, onClick: (clickBtnType: number) => void) => {
    this.setState({
      showBestDiscount: false,
      showPaymentChannelDialog: true,
      commonDialogInfo: {
        title: popupInfo?.title || '',
        message: popupInfo?.message || '',
        leftBtnText: popupInfo?.leftBtnText || '',
        rightBtnText: popupInfo?.rightBtnText || '',
        onClickLeftBtn: () => {
          this.setState(
            {
              showPaymentChannelDialog: false,
            },
            () => {
              onClick?.(DialogButtonType.Left)
            },
          )
        },
        onClickRightBtn: () => {
          onClick?.(DialogButtonType.Right)
        },
      },
    })
  }

  onClicPaymentChannelCouponkRightBtn = (item: OrderCouponInfo) => {
    const { enabledCouponList } = this.state
    const newEnabledCouponList = enabledCouponList.map(v => ({
      ...v,
      selected: item.couponViewId === v.couponViewId ? !v.selected : false,
    }))
    this.setState({
      showPaymentChannelDialog: false,
      enabledCouponList: newEnabledCouponList,
      selectedCouponAmount: !item.selected ? +item.couponAmountString : 0,
    })
    const paymethodList = item.payChannelInfo?.payChannelCodeList ?? []
    this.setState(
      prevState => ({
        selectedCouponId: !item.selected ? item.couponViewId : '',
        backOrderPageData: {
          ...prevState.backOrderPageData,
          paymethodList,
        },
      }),
      () => {
        this.confirmClick(true)
      },
    )
  }

  /**
   * 跳转历史优惠页面
   */
  jumpHistoryCouponPage = () => {
    const page_source = Mach.env.schemeParams?.page_source || 1
    moduleTracker({
      cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
      bid: JudasConstant.MY_COUPON_HISTORY_ENTRY_MC,
      valLab: { page_source: page_source },
    })
    // 页面跳转
    const bundleName = 'mach_pro_sailor_c_market_history_coupon_list'
    const data = { pageSource: PageSourceType.ORDER_COUPON_LIST }
    jumpTo({
      urlInfo: {
        url: SCHEME_MACHPRO_WITH_PRE,
        query: {
          mach_bundle_name: bundleName,
        },
      },
      customParam: data,
      // onSuccess: () => {
      //   console.log('成功')
      // },
      // onError: error => {
      //   console.log('失败', error)
      // },
    })
  }

  /**
   * 提交数据到提单页
   * @param navigateBack 是否返回提单页
   */
  confirmClick = (navigateBack?: boolean) => {
    const backOrderPageData = {
      selectedCouponId: this.state.selectedCouponId,
      ...this.state.backOrderPageData,
    }
    KNB.setResult({
      resultCode: KNB.setResult.RESULT_OK,
      resultData: backOrderPageData ? JSON.stringify(backOrderPageData) : '', // 只支持string类型 有数据结构需求，可考虑放json字符串
      success () {
        if (navigateBack) jumpTo({ type: RouterType.BACK })
      },
      fail () {
        if (navigateBack) jumpTo({ type: RouterType.BACK })
      },
    })
  }

  /**
   * 打开兑换弹窗
   */
  openPromoDialog = () => {
    const page_source = Mach.env.schemeParams?.page_source || 1
    moduleTracker({
      cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
      bid: JudasConstant.ORDER_COUPON_EXCHANGE_ENTRY_MC,
      valLab: { page_source: page_source },
    })
    this.setState({
      showBestDiscount: false,
      promoDialogVisible: true,
      promoFailTips: '',
    })
  }

  /**
   * 关闭兑换弹窗
   */
  closePromoDialog = () => {
    this.setState({
      promoDialogVisible: false,
      promoFailTips: '',
    })
  }

  /**
   * 提交兑换码
   */
  commitPromoCode = (keyword: string) => {
    const page_source = Mach.env.schemeParams?.page_source || 1
    // 入参构造
    const shopId = Mach.data.shopId
    const addressInfo = Mach.data.addressInfo
    const couponThresholdInfo = Mach.data.couponThresholdInfo
    const orderSource = Mach.data.orderSource
    const userGetMode = Mach.data.userGetMode || 'delivery' // 默认外卖
    const { actualLatitude, actualLongitude } = getUserLocation()
    // 第三方APP安装信息列表
    const appInstallationInfoList = this.getAppInstallInfoList()
    const bundleVersion = Mach.env.bundleVersion ?? ''
    const exchangeRequest: OrderCouponsExchangeRequest = {
      exchangeCode: keyword,
      shopId: shopId,
      addressInfo: addressInfo,
      couponThresholdInfo: couponThresholdInfo,
      orderSource: orderSource,
      actualLatitude: actualLatitude,
      actualLongitude: actualLongitude,
      appInstallationInfoList,
      userGetMode,
      bundleVersion,
    }
    // 接口请求
    orderCouponExchange(exchangeRequest)
      .then(result => {
        // 兑换服务失败，弹窗展示失败文案
        if (result && result.code !== 0 && result.code !== 301003406) {
          KNB.vibrate({
            duration: 1000,
          })
          this.setState({
            promoFailTips: result.message,
          })
          moduleTracker({
            type: ModuleLxType.MV,
            cid: JudasConstant.ORDER_COUPON_PROMO_CID,
            bid: JudasConstant.COUPON_PROMO_FAIL_MV,
            valLab: { remind_reason: result?.code },
          })
          return
        }
        // 兑换服务成功，关闭弹窗
        this.setState({
          promoDialogVisible: false,
        })
        if (result && result?.code === 0) {
          // 兼容数组/对象类型
          const promoCodeData = result?.data?.exchangeCouponList && isArray(result?.data?.exchangeCouponList) ? result?.data?.exchangeCouponList : result?.data ? [result?.data] : []
          // this.hasFirstOrderCoupon = result?.data?.hasFirstOrderCoupon
          // this.hasFirstOrderCoupon = promoCodeData.some((item: any) => item.hasFirstOrderCoupon)
          const { selectedCouponId } = this.state
          const couponViewIdList = compact(promoCodeData.map((item: any) => item?.couponViewId)) as string[]
          // const couponViewId = result?.data?.couponViewId
          // const paymethodList = result.data?.payChannelCodeList ?? []
          // if (result?.data?.preUseCouponStatus === PreUseCouponStatus.coupon_unuseable) {
          // 都是不可用
          if (promoCodeData.every((item: any) => item.preUseCouponStatus === PreUseCouponStatus.coupon_unuseable)) {
            const lab = {
              coupon_id: compact(promoCodeData.map((item: any) => item?.couponConfigId)).join(',') || '',
              page_source: page_source,
            }
            moduleTracker({
              type: ModuleLxType.MV,
              cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
              bid: JudasConstant.ORDER_COUPON_EXCHANGE_UNUSEABLE_MV,
              valLab: lab,
            })
            this.setState({
              showBestDiscount: false,
              showPaymentChannelDialog: true,
              commonDialogInfo: {
                title: i18nClient.getText('coupon_submit_unusable_popup_title_multiple'),
                leftBtnText: i18nClient.getText('coupon_submit_unusable_popup_button_left'),
                rightBtnText: i18nClient.getText('coupon_submit_unusable_popup_button_right'),
                onClickLeftBtn: () => {
                  const clickLab = {
                    ...lab,
                    button_name: i18nClient.getText('coupon_submit_unusable_popup_button_left'),
                  }
                  moduleTracker({
                    cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
                    bid: JudasConstant.ORDER_COUPON_EXCHANGE_UNUSEABLE_MC,
                    valLab: clickLab,
                  })
                  this.setState({
                    showPaymentChannelDialog: false,
                  })
                  this.unuseableCouponDetailClick(couponViewIdList, selectedCouponId)
                },
                onClickRightBtn: () => {
                  const clickLab = {
                    ...lab,
                    button_name: i18nClient.getText('coupon_submit_unusable_popup_button_right'),
                  }
                  moduleTracker({
                    cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
                    bid: JudasConstant.ORDER_COUPON_EXCHANGE_UNUSEABLE_MC,
                    valLab: clickLab,
                  })
                  this.setState({
                    showPaymentChannelDialog: false,
                  })
                  // 改为停留在当前
                  this.unuseableCouponCloseClick(couponViewIdList, selectedCouponId, true)
                },
              },
            })
            // } else if (result?.data?.preUseCouponStatus === PreUseCouponStatus.coupon_useable) {
            // 都是可用
          } else if (promoCodeData.every((item: any) => item.preUseCouponStatus === PreUseCouponStatus.coupon_useable)) {
            Toast.show(i18nClient.getText('coupon_promocode_showlist_sucess_toast'), 2)
            this.unuseableCouponCloseClick(couponViewIdList, selectedCouponId, true)
            // if (!result?.data?.firstOrderLimit && this.hasFirstOrderCoupon) {
            //   // 非首单券限制
            //   this.selectNonFirstOrderLimitCoupon({ pop_type: 2, coupon_id: result?.data?.couponConfigId }, (clickBtnType, clickBtnText) => {
            //     if (clickBtnType === DialogButtonType.Left) {
            //       // 用户选择继续流程
            //       if (result?.data?.couponReminderInfo) {
            //         // 支付渠道限制
            //         this.selectPaymentChannelCoupon(result?.data ?? {}, true)
            //       } else {
            //         this.confirmClick(couponViewId, true, paymethodList)
            //       }
            //     } else if (clickBtnType === DialogButtonType.Right) {
            //       // 用户选择取消选券，此时刷新券列表
            //       this.unuseableCouponCloseClick(couponViewId, selectedCouponId)
            //     }
            //     moduleTracker({
            //       cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,f v
            //       bid: JudasConstant.ORDER_COUPON_FIRSE_LIMIT_MC,
            //       valLab: {
            //         pop_type: 2,
            //         coupon_id: result?.data?.couponConfigId,
            //         button_name: clickBtnText,
            //       },
            //     })
            //   })
            // } else {
            //   if (result?.data?.couponReminderInfo) {
            //     // 支付渠道限制
            //     this.selectPaymentChannelCoupon(result?.data ?? {}, true)
            //   } else {
            //     this.confirmClick(couponViewId, true, paymethodList)
            //   }
            // }
            // 部分可用部分不可用
          } else {
            Toast.show(i18nClient.getText('coupon_promocode_showlist_sucess_toast'), 2)
            // 不可用的后端能否置顶
            this.unuseableCouponCloseClick(couponViewIdList, selectedCouponId, true)
          }
        } else {
          const Toast = Mach.requireModule('Toast')
          Toast.show(result?.message, 2)
          // 301003406 标识兑换券服务成功但预用服务异常
          if (result?.code === 301003406) {
            // 刷新券列表
            this.reqCouponList()
          }
        }
      })
      .catch(error => {
        // 兑换失败，刷新弹窗失败文案
        KNB.vibrate({
          duration: 1000,
        })
        this.setState({
          promoFailTips: i18nClient.getText('coupon_display_list_access_error_text'),
        })
        // 非接口服务导致的异常上报-1
        moduleTracker({
          type: ModuleLxType.MV,
          cid: JudasConstant.ORDER_COUPON_PROMO_CID,
          bid: JudasConstant.COUPON_PROMO_FAIL_MV,
          valLab: { remind_reason: -1 },
        })
      })
  }

  /**
   * 获取第三方应用安装信息列表
   */
  getAppInstallInfoList = () => {
    const appNameList = [THIRD_APP_NAME.WECHAT]
    // 待检测列表
    const detectList = [
      {
        // 微信安装信息
        appName: THIRD_APP_NAME.WECHAT,
        schemeName: THIRD_APP_SCHEME.WECHAT,
        packageName: THIRD_APP_PACKAGE.WECHAT,
      },
    ]
    // 检测app安装列表
    const detectResultList: any[] = []
    detectList.forEach(item => {
      let isInstalled = false
      SLCommon?.isInstalledApp?.({ scheme: item.schemeName, package: item.packageName }, (result: any) => {
        isInstalled = result?.installed ?? false
      })
      const detectItemInfo = { appName: item.appName, installed: isInstalled }
      detectResultList.push(detectItemInfo)
    })
    return detectResultList
  }

  /**
   * 点击兑换--券不可用弹窗--查看细则弹窗
   * @param couponViewId 兑换券的id
   * @param selectedCouponId 已选中的券id
   */
  unuseableCouponDetailClick = (couponViewId: string | string[], selectedCouponId: string) => {
    const orderCouponsReqParams = this.refreshCouponRequest(couponViewId, selectedCouponId)
    // 接口请求
    if (!orderCouponsReqParams) {
      return
    }
    orderCouponListRequest(orderCouponsReqParams)
      .then(result => {
        this.hasFirstOrderCoupon = result?.hasFirstOrderCoupon
        this.exchangeCoupon = {
          enabledCoupon: (result?.enabledCouponList || []).map((item: any) => couponViewId.indexOf(item.couponViewId) !== -1),
          disabledCoupon: (result?.disabledCouponList || []).map((item: any) => couponViewId.indexOf(item.couponViewId) !== -1),
        }
        if (result?.enabledCouponList) {
          const filterList = (result?.enabledCouponList || []).filter((item: OrderCouponInfo) => item.selected === true)
          if (filterList && filterList.length > 0) {
            this.setState({
              selectedCouponAmount: filterList[0].couponAmountString,
              selectedCouponId: filterList[0].couponViewId,
            })
            this.setState(prevState => ({
              backOrderPageData: {
                ...prevState.backOrderPageData,
                paymethodList: filterList[0]?.payChannelInfo?.payChannelCodeList || [],
              },
            }))

            // ----- mpweb适配origin -----
            // ----- mpweb适配change -----
            // @ts-ignore
            result.enabledCouponList = (result?.enabledCouponList || []).filter((item: OrderCouponInfo) => {
              if (payReminderTypes.includes(item?.couponReminderInfo?.type)) {
                if (!item.unusableReasonDocList?.length) {
                  item.unusableReasonDocList = item.shortUseRuleDocList;
                }
                // @ts-ignore
                result.disabledCouponList = result?.disabledCouponList || [];
                // @ts-ignore
                result.disabledCouponList.push({ ...item })
                return false;
              } else {
                return true;
              }
            })
            // ----- mpweb适配       -----
          }
        }
        this.setState(
          {
            enabledCouponList: result?.enabledCouponList || [],
            disabledCouponList: result?.disabledCouponList || [],
            couponPackData: result?.apPreviewData,
            emptyText: [i18nClient.getText('coupon_display_list_default_text')],
          },
          () => {
            // TODO：改为锚定到不可用
            this.scrollToSection(1, 0)
          },
        )
      })
      .catch(error => {
        if (error === 'error') {
          this.setState({
            emptyText: i18nClient.getText('coupon_display_list_access_error_text'),
          })
        } else {
          this.setState({
            emptyText: [i18nClient.getText('coupon_display_list_default_text')],
          })
        }
      })
  }

  /**
   * 点击兑换--券不可用弹窗--关闭按钮
   * @param couponViewId 兑换券的id
   * @param selectedCouponId 已选中的券id
   */
  unuseableCouponCloseClick = (couponViewId: string | string[], selectedCouponId: string, isExchange?: boolean) => {
    const orderCouponsReqParams = this.refreshCouponRequest(couponViewId, selectedCouponId)
    if (!orderCouponsReqParams) {
      return
    }
    orderCouponListRequest(orderCouponsReqParams)
      .then(result => {
        this.hasFirstOrderCoupon = result?.hasFirstOrderCoupon
        this.exchangeCoupon = {
          enabledCoupon: (result?.enabledCouponList || []).map((item: any) => isExchange && couponViewId.indexOf(item.couponViewId) !== -1),
          disabledCoupon: (result?.disabledCouponList || []).map((item: any) => isExchange && couponViewId.indexOf(item.couponViewId) !== -1),
        }
        if (result?.enabledCouponList) {
          const filterList = (result?.enabledCouponList || []).filter((item: OrderCouponInfo) => item.selected === true)
          if (filterList && filterList.length > 0) {
            this.setState({
              selectedCouponAmount: filterList[0].couponAmountString,
              selectedCouponId: filterList[0].couponViewId,
            })
            this.setState(prevState => ({
              backOrderPageData: {
                ...prevState.backOrderPageData,
                paymethodList: filterList[0]?.payChannelInfo?.payChannelCodeList || [],
              },
            }))
            // ----- mpweb适配origin -----
            // ----- mpweb适配change -----
            // @ts-ignore
            result.enabledCouponList = (result?.enabledCouponList || []).filter((item: OrderCouponInfo) => {
              if (payReminderTypes.includes(item?.couponReminderInfo?.type)) {
                if (!item.unusableReasonDocList?.length) {
                  item.unusableReasonDocList = item.shortUseRuleDocList;
                }
                // @ts-ignore
                result.disabledCouponList = result?.disabledCouponList || [];
                // @ts-ignore
                result.disabledCouponList.push({ ...item })
                return false;
              } else {
                return true;
              }
            })
            // ----- mpweb适配       -----
          }
        }
        this.setState({
          enabledCouponList: result?.enabledCouponList || [],
          disabledCouponList: result?.disabledCouponList || [],
          couponPackData: result?.apPreviewData,
          emptyText: [i18nClient.getText('coupon_display_list_default_text')],
        })
      })
      .catch(error => {
        if (error === 'error') {
          this.setState({
            emptyText: i18nClient.getText('coupon_display_list_access_error_text'),
          })
        } else {
          this.setState({
            emptyText: [i18nClient.getText('coupon_display_list_default_text')],
          })
        }
      })
  }

  /**
   * 点击兑换--券不可用弹窗--操作刷新券列表
   */
  refreshCouponRequest = (couponId: string | string[], selectedCouponId: string) => {
    if (!Mach.data) return null

    const shopId = Mach.data.shopId
    const couponViewId = selectedCouponId
    const addressInfo = Mach.data.addressInfo
    const couponThresholdInfo = Mach.data.couponThresholdInfo
    const orderSource = Mach.data.orderSource
    const userGetMode = Mach.data.userGetMode || 'delivery' // 默认外卖
    const orderToken = Mach.data.token
    const { actualLatitude, actualLongitude } = getUserLocation()
    const bundleVersion = Mach.env.bundleVersion ?? ''
    let topSortCouponViewId: string[] = []
    if (selectedCouponId !== '') {
      topSortCouponViewId.push(selectedCouponId)
    }
    if (!isEmpty(couponId)) {
      topSortCouponViewId = isArray(couponId) ? [...topSortCouponViewId, ...couponId] : [...topSortCouponViewId, couponId]
    }
    // 第三方APP安装信息列表
    const appInstallationInfoList = this.getAppInstallInfoList()
    // 入参构造
    const orderCouponsReqParams: OrderCouponsRequest = {
      couponViewId: couponViewId,
      shopId: shopId,
      actualLongitude: actualLongitude,
      actualLatitude: actualLatitude,
      addressInfo: addressInfo,
      orderSource: orderSource,
      couponThresholdInfo: couponThresholdInfo,
      topSortCouponViewId: topSortCouponViewId,
      appInstallationInfoList,
      userGetMode,
      bundleVersion,
      orderToken,
    }
    return orderCouponsReqParams
  }

  scrollToSection = (section: number, item: number) => {
    this.sectionListRef?.scrollToItem(
      {
        section: section,
        item: item,
      },
      {
        animated: true,
      },
    )
  }

  /**
   * 上报用户优惠券数量&售卖券数量（可使用）
   */
  reportCouponCount = (couponList: any[] = []) => {
    const couponTotalCount = couponList?.reduce((pre, cur) => pre + (cur?.count || 0), 0)
    const sellCouponTotalCount = couponList?.reduce((pre, cur) => {
      if (cur?.packSceneId === CouponPackType.SELL) {
        return pre + (cur?.count || 0)
      }
      return pre
    }, 0)
    // 上报用户优惠券数量
    reportRaptorMetrics({ user_coupon_totalcount: couponTotalCount || 0 }, { count: couponTotalCount || 0 })
    // 上报用户售卖券数量
    reportRaptorMetrics({ user_sell_coupon_totalcount: sellCouponTotalCount || 0 }, { count: sellCouponTotalCount || 0 })
  }

  /**
   * 券包勾选回调
   */
  handleCouponPackChoose = (selectInfo: ApInputRequest[]) => {
    this.setState(
      prevState => ({
        backOrderPageData: {
          ...prevState.backOrderPageData,
          changedPackages: selectInfo,
        },
      }),
      () => {
        this.reqCouponList()
      },
    )
  }

  /**
   * 更新返回提单页的数据（productBuyId和selected以接口下发的为准）
   */
  updateBackOrderPageData = (apPreviewData: any) => {
    const parseData = isJSON(apPreviewData?.content)
    if (!parseData || !this.state.backOrderPageData?.changedPackages?.[0]?.productId) return

    const changedProductCard = (parseData?.productCards || []).find((item: any) => item.channelProductId === this.state.backOrderPageData?.changedPackages?.[0]?.productId)

    this.setState(
      prevState => ({
        backOrderPageData: {
          ...prevState.backOrderPageData,
          changedPackages: [
            {
              ...prevState.backOrderPageData.changedPackages?.[0],
              productBuyId: changedProductCard?.productBuyId,
              selected: changedProductCard?.selected,
            },
          ],
        },
      }),
      () => {
        this.confirmClick(false)
      },
    )
  }

  /**
   * 更新请求参数的apExtra字段(透传上一次请求返回中的字段)
   */
  updateCouponListReqApExtra = (apPreviewData: any) => {
    const parseData = isJSON(apPreviewData?.content)
    this.couponListReqApExtra.request_id = parseData?.requestId
  }

  /**
   * 获取券包组件的埋点配置
   */
  getCouponPackLxConfig = () => ({
    cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
    mvBid: JudasConstant.ORDER_COUPON_COUPONPACK_MV,
    sub: {
      mvBid: JudasConstant.ORDER_COUPON_COUPONPACK_SUB_MV,
      mcBid: JudasConstant.ORDER_COUPON_COUPONPACK_SUB_MC,
    },
    couponList: {
      haveReportedCouponPack: this.state.haveReportedCouponPack,
      haveReportedVoucherPack: this.state.haveReportedVoucherPack,
      haveChoosedVoucherPack: this.state.haveChoosedVoucherPack,
      setHaveReportedCouponPack: (val: boolean) => this.setState({ haveReportedCouponPack: val }),
    },
  })

  /**
   * 券列表-膨胀按钮点击处理
   */
  handleCouponListUpgradeBtnClick = (item: OrderCouponInfo, indexPath: IndexPath) => {
    this.currentUpgradeCoupon = item
    this.setState({
      couponUpgradeModalVisible: true,
      couponUpgradeModalData: {
        title: `${i18nClient.getText('upgraded_title', 'Koupon upgraded!')}`, // 主标题
        inflateCouponInfo: item?.inflateCouponInfo, // 膨胀券信息，与券系统保持一致
        originalCouponInfo: {
          // 当前券信息
          couponAmount: item?.couponAmountString, // 券面额，单位元
          sillAmount: item?.sillAmountString, // 券门槛，单位元
          currencyCode: item?.currencyType, // 货币符号
          couponConfigId: item?.couponConfigId, // 券配置id
        },
      },
    })
    // 膨胀按钮点击埋点
    const lab = this.getCommonLab(item, indexPath)
    const couponLab = {
      ...lab,
      button_status: item.selected,
    }
    moduleTracker({ cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID, bid: JudasConstant.ORDER_COUPON_UPGRADE_BUTTON_MC, valLab: couponLab })
    reportRaptorMetrics({ UPGRADE_BTN_MC: 1 }, { source: SaleChannel.COUPON_LIST_PAGE, coupon_id: item?.couponConfigId })
  }

  /**
   * 膨胀弹窗-膨胀按钮点击处理
   */
  handleUpgradeBtnClick = (): Promise<boolean> => {
    const couponInfo = this.currentUpgradeCoupon
    const { actualLatitude, actualLongitude, latitude, longitude } = getUserLocation()
    const params: CouponUpgradeRequest = {
      upgradeCouponInfo: {
        fromCouponConfigId: couponInfo?.couponConfigId,
        fromCouponViewId: couponInfo?.couponViewId,
        upgradeAfterInfoList: [
          {
            toCouponConfigId: couponInfo?.inflateCouponInfo?.upgradeCouponConfigId?.[0],
            sellInfo: {
              sillAmount: couponInfo?.inflateCouponInfo?.upgradeSillAmount,
              couponAmount: couponInfo?.inflateCouponInfo?.upgradeAmount,
            },
          },
        ],
      },
      source: SaleChannel.COUPON_LIST_PAGE,
      shopId: Mach.data.shopId,
      riskApiCommonParam: {
        actualLongitude,
        actualLatitude,
        homePageLongitude: longitude,
        homePageLatitude: latitude,
      },
    }
    // 弹窗膨胀按钮点击上报
    reportRaptorMetrics({ EXPANSION_COUPON_CLICK: 1 }, { source: SaleChannel.COUPON_LIST_PAGE, coupon_id: couponInfo?.couponConfigId })
    return couponUpgrade(params)
      .then(async result => {
        if (result?.code === 0) {
          this.upgradedCouponId = result?.data?.upgradeInfo?.[0]?.upgradeAfterInfoList?.[0]?.toCouponViewId || ''
          await this.reqCouponList()
          // 膨胀接口调用上报
          reportRaptorMetrics({ EXPANSION_COUPON_API: 1 }, { source: SaleChannel.COUPON_LIST_PAGE, status: 1, code: result?.code, message: result?.msg })
          return true
        } else {
          if (result?.code === 103) {
            // 若加码金额变更，则刷新弹窗中的加码金额
            result?.msg && Toast.show(result?.msg, 2)
            const sellInfo = result?.data?.upgradeInfo?.[0]?.upgradeAfterInfoList?.[0]?.sellInfo || {}
            this.setState(prevState => {
              // 更新膨胀弹窗展示数据、当前券的膨胀金额和门槛
              const index = prevState.enabledCouponList.findIndex(item => item.couponViewId === this.currentUpgradeCoupon.couponViewId)
              if (index === -1 || !sellInfo) {
                return null
              }
              const updatedCouponList = prevState.enabledCouponList.map((item, idx) => {
                if (idx === index) {
                  return {
                    ...item,
                    inflateCouponInfo: {
                      ...item.inflateCouponInfo,
                      upgradeAmount: sellInfo?.couponAmount,
                      upgradeSillAmount: sellInfo?.sillAmount,
                      upgradeAmountText: sellInfo?.showCouponAmount,
                      upgradeSillAmountText: sellInfo?.showSillAmount,
                    },
                  }
                }
                return item
              })
              return {
                couponUpgradeModalData: {
                  ...prevState.couponUpgradeModalData,
                  inflateCouponInfo: {
                    ...prevState.couponUpgradeModalData.inflateCouponInfo,
                    upgradeAmount: sellInfo?.couponAmount,
                    upgradeSillAmount: sellInfo?.sillAmount,
                    upgradeAmountText: sellInfo?.showCouponAmount,
                    upgradeSillAmountText: sellInfo?.showSillAmount,
                  },
                },
                enabledCouponList: updatedCouponList,
              }
            })
            this.currentUpgradeCoupon.inflateCouponInfo.upgradeAmount = sellInfo?.couponAmount
            this.currentUpgradeCoupon.inflateCouponInfo.upgradeSillAmount = sellInfo?.sillAmount
          } else {
            setTimeout(() => {
              // 兼容安卓toast不展示
              Toast.show(i18nClient.getText('koupon_bug', '系统正忙，请重试'), 2)
            }, 0)
            this.setState({
              couponUpgradeModalVisible: false,
            })
            this.reqCouponList()
          }
          // 膨胀接口调用上报
          reportRaptorMetrics({ EXPANSION_COUPON_API: 0 }, { source: SaleChannel.COUPON_LIST_PAGE, status: 0, code: result?.code, message: result?.msg })
          return false
        }
      })
      .catch(error => {
        setTimeout(() => {
          // 兼容安卓toast不展示
          Toast.show(i18nClient.getText('koupon_bug', '系统正忙，请重试'), 2)
        }, 0)
        this.setState({
          couponUpgradeModalVisible: false,
        })
        this.reqCouponList()
        // 膨胀接口调用上报
        reportRaptorMetrics({ EXPANSION_COUPON_API: 0 }, { source: SaleChannel.COUPON_LIST_PAGE, status: 0, message: 'error' })
        return false
      })
  }

  /**
   * 膨胀弹窗-使用按钮点击处理
   */
  handleUpgradeApplyBtnClick = () => {
    const currentCoupon = this.state.enabledCouponList.find(item => item.couponViewId === this.upgradedCouponId)
    this.setState(
      prevState => ({
        couponUpgradeModalVisible: false,
        selectedCouponId: currentCoupon?.couponViewId || '',
        backOrderPageData: {
          ...prevState.backOrderPageData,
          paymethodList: currentCoupon?.payChannelInfo?.payChannelCodeList || [],
        },
      }),
      () => {
        this.confirmClick(true)
      },
    )
  }

  /**
   * 膨胀弹窗-关闭按钮(膨后)点击处理
   */
  handlePostUpgradeCloseBtnClick = () => {
    this.setState({
      couponUpgradeModalVisible: false,
    })
    this.upgradedCouponId = ''
  }

  /**
   * 获取膨胀弹窗组件的埋点配置
   */
  getCouponUpgradeLxConfig = () => ({
    cid: JudasConstant.ORDER_CONFIRM_COUPON_LIST_CID,
    preUpgrade: {
      mvBid: JudasConstant.ORDER_COUPON_UPGRADE_MODAL_PREUPGRADE_MV,
      mcBid: JudasConstant.ORDER_COUPON_UPGRADE_MODAL_PREUPGRADE_MC,
    },
    postUpgrade: {
      mvBid: JudasConstant.ORDER_COUPON_UPGRADE_MODAL_POSTUPGRADE_MV,
    },
  })

  render () {
    const rightComponent = (
      <view className="title-right-container" onClick={() => this.jumpHistoryCouponPage()}>
        <text className="history-coupon-text">{i18nClient.getText('coupon_list_page_history_title')}</text>
      </view>
    )
    const leftComponent = (
      <view className="title-left-container">
        <text className="left-coupon-text ">{i18nClient.getText('coupon_list_page_title')}</text>
      </view>
    )
    const {
      loading,
      showPaymentChannelDialog,
      enabledCouponList,
      disabledCouponList,
      commonDialogInfo,
      emptyText,
      promoDialogVisible,
      promoFailTips,
      couponPackData,
      couponUpgradeModalVisible,
      couponUpgradeModalData,
    } = this.state
    const hasOrderCoupon = (enabledCouponList || []).find(item => !item?.unusableReasonDocList)
    const hasUnableOrderCoupon = (disabledCouponList || []).find(item => item?.unusableReasonDocList && (item.unusableReasonDocList || []).length > 0)
    const isShowEmptyView = !loading && !hasOrderCoupon && !hasUnableOrderCoupon
    const isShowCouponPack = couponPackData && couponPackData?.show && Mach.data?.features?.voucherPackage?.supported // 是否展示券包

    return (
      <view className="app">
        <NavigateBar leftTitle={i18nClient.getText('coupon_list_page_title')} rightComponent={rightComponent} />

        <view className="list-wrap">
          <view className="exchange-code-container">
            <view className="exchange-wapper" onClick={() => this.openPromoDialog()}>
              <image src="assets://icon/coupon/icon_exchange_code.png" className="exchange-icon" autoRTL />
              <text className="exchange-hint-text">{i18nClient.getText('coupon_promocode_enterbar')}</text>
            </view>
          </view>
          {(!isShowEmptyView || isShowCouponPack) && (
            <view className="container">
              <SectionList
                ref={ref => {
                  this.sectionListRef = ref
                }}
                renderItem={info =>
                  this.renderItem(info, {
                    hasUnableOrderCoupon: !!hasUnableOrderCoupon,
                  })
                }
                showScrollIndicator={false}
                sections={this.sectionData()}
                renderSectionHeader={this.renderSectionHeader}
                onCellAppear={this.onCellAppear}
                cellHeightCacheKey={this.cellHeightCacheKey}
                headerView={this.renderCouponPack}
                footerView={() => this.renderEmptyView(isShowEmptyView)}
                extraData={this.state.couponPackData}
                scrollEnabled={!isShowEmptyView}
              />
            </view>
          )}
          {/* 兜底区*/}
          {isShowEmptyView && !isShowCouponPack && (
            <view className="empty-wrap" style={{ height: '100%' }}>
              <EmptyView emptyText={emptyText} />
            </view>
          )}

          {/* 兑换弹窗*/}
          {promoDialogVisible && <OrderCouponPromoDialog onClickCloseBtn={this.closePromoDialog} onClickCommitBtn={this.commitPromoCode} promoFailTips={promoFailTips}></OrderCouponPromoDialog>}
        </view>

        {showPaymentChannelDialog && (
          <CommonDialog
            title={commonDialogInfo.title}
            message={commonDialogInfo.message}
            leftBtnText={commonDialogInfo.leftBtnText}
            rightBtnText={commonDialogInfo.rightBtnText}
            onClickLeftBtn={commonDialogInfo.onClickLeftBtn}
            onClickRightBtn={commonDialogInfo.onClickRightBtn}
          />
        )}

        {/* 膨胀券弹窗 */}
        {couponUpgradeModalVisible && (
          <CouponUpgradeModal
            data={couponUpgradeModalData}
            source={SaleChannel.COUPON_LIST_PAGE}
            i18nClient={i18nClient}
            lxConfig={this.getCouponUpgradeLxConfig()}
            onUpgradeBtnClick={this.handleUpgradeBtnClick}
            onApplyBtnClick={this.handleUpgradeApplyBtnClick}
            onPreUpgradeCloseBtnClick={() => this.setState({ couponUpgradeModalVisible: false })}
            onPostUpgradeCloseBtnClick={this.handlePostUpgradeCloseBtnClick}
          />
        )}
      </view>
    )
  }
}
